import { FC } from "react";
import { useTranslation } from "react-i18next";

import SyncIcon from "@/components/icons/SyncIcon";
import { Button } from "@/components/ui/v2/button";
import useClientSync from "@/lib/hooks/useClientSync";
import useToast from "@/lib/hooks/useToast";

type SyncButtonProps = {
  clientId: string;
};

const SyncButton: FC<SyncButtonProps> = ({ clientId }) => {
  const { startSync, syncStatus } = useClientSync(clientId);
  const { t } = useTranslation();
  const { showToast } = useToast();
  const isDisabled = syncStatus === "inProgress" || false;

  // Determine button label
  const getButtonLabel = () => {
    if (syncStatus === "inProgress") return "common.syncing";
    return "common.resync";
  };

  return (
    <Button
      variant="outline"
      onClick={async () => {
        try {
          await startSync.exec();
          showToast(t("success.resyncStarted"), "success");
        } catch {
          showToast(t("errors.resyncFailed"), "error");
        }
      }}
      disabled={isDisabled}
    >
      <span className="inline-flex items-center gap-2">
        <SyncIcon
          className={isDisabled ? "animate-spin" : undefined}
          fontSize={"1.3rem"}
        />
        {t(getButtonLabel())}
      </span>
    </Button>
  );
};

export default SyncButton;
